import availTexture from 'assets/avail-fs8.png';
import basePhone1 from 'assets/base_phone_1-fs8.png';
import basePhone2 from 'assets/base_phone_2-fs8.png';
import gamestackTexture2Large from 'assets/gamestack-list-large.jpg';
import gamestackTexture2Placeholder from 'assets/gamestack-list-placeholder.jpg';
import gamestackTexture2 from 'assets/gamestack-list.jpg';
import gamestackTextureLarge from 'assets/gamestack-login-large.jpg';
import gamestackTexturePlaceholder from 'assets/gamestack-login-placeholder.jpg';
import gamestackTexture from 'assets/gamestack-login.jpg';
import epicaMobileOne from 'assets/epica-mobile.png';
import epicaMobileTwo from 'assets/epica-mobile-2.png';
import availMobileOne from 'assets/avail-mobile.png';
import availMobileTwo from 'assets/avail-mobile-2.png';
import tabulaMobileFour from 'assets/tabula-mobile-4.png';
import tabulaMobileFive from 'assets/tabula-mobile-5.png';
import undentifySmall from 'assets/udentify-small.png';
import undentifyBig from 'assets/udentify-big.png';
import blockChainSmall from 'assets/blockchain-small.png';
import blockChainBig from 'assets/blockchain-big.png';

// import iphone11 from 'assets/iphone-11.glb';
// import macbookPro from 'assets/macbook-pro.glb';
import sliceTextureLarge from 'assets/slice-app-large.jpg';
import sliceTextureLarge1 from 'assets/slice-app-large1.jpg';
import sliceTexturePlaceholder from 'assets/slice-app-placeholder.jpg';
import sliceTexture from 'assets/slice-app.jpg';
import sliceTexture_app_internship from 'assets/slice-app_internship.jpg';
import sprTextureLarge from 'assets/spr-lesson-builder-dark-large.jpg';
import sprTexturePlaceholder from 'assets/spr-lesson-builder-dark-placeholder.jpg';
import sprTexture from 'assets/spr-lesson-builder-dark.jpg';
import Footer from 'components/Footer';
import {usePrefersReducedMotion, useRouteTransition} from 'hooks';
import Intro from 'pages/Home/Intro';
import Profile from 'pages/Home/Profile';
import ProjectSummary from 'pages/Home/ProjectSummary';
import ProjectSummaryButtonless from 'pages/Home/ProjectSummaryButtonless';
import {useEffect, useRef, useState} from 'react';
import {Helmet} from 'react-helmet';
import {useLocation} from 'react-router-dom';
import './index.css';


// const availTexture = 'https://portfoliodeland.s3.us-east-2.amazonaws.com/assets/avail-fs8.png';
// const basePhone1 = 'https://portfoliodeland.s3.us-east-2.amazonaws.com/assets/base_phone_1-fs8.png';
// const basePhone2 = 'https://portfoliodeland.s3.us-east-2.amazonaws.com/assets/base_phone_2-fs8.png';
// const gamestackTexture2Large = 'https://portfoliodeland.s3.us-east-2.amazonaws.com/assets/gamestack-list-large.jpg';
// const gamestackTexture2Placeholder = 'https://portfoliodeland.s3.us-east-2.amazonaws.com/assets/gamestack-list-placeholder.jpg';
// const gamestackTexture2 = 'https://portfoliodeland.s3.us-east-2.amazonaws.com/assets/gamestack-list.jpg';
// const gamestackTextureLarge = 'https://portfoliodeland.s3.us-east-2.amazonaws.com/assets/gamestack-login-large.jpg';
// const gamestackTexturePlaceholder = 'https://portfoliodeland.s3.us-east-2.amazonaws.com/assets/gamestack-login-placeholder.jpg';
// const gamestackTexture = 'https://portfoliodeland.s3.us-east-2.amazonaws.com/assets/gamestack-login.jpg';
const iphone11 = 'https://portfoliodeland.s3.us-east-2.amazonaws.com/assets/iphone-11.glb';
const macbookPro = 'https://portfoliodeland.s3.us-east-2.amazonaws.com/assets/macbook-pro.glb';
// const sliceTextureLarge = 'https://portfoliodeland.s3.us-east-2.amazonaws.com/assets/slice-app-large.jpg';
// const sliceTextureLarge1 = 'https://portfoliodeland.s3.us-east-2.amazonaws.com/assets/slice-app-large1.jpg';
// const sliceTexturePlaceholder = 'https://portfoliodeland.s3.us-east-2.amazonaws.com/assets/slice-app-placeholder.jpg';
// const sliceTexture = 'https://portfoliodeland.s3.us-east-2.amazonaws.com/assets/slice-app.jpg';
// const sliceTexture_app_internship = 'https://portfoliodeland.s3.us-east-2.amazonaws.com/assets/slice-app_internship.jpg';
// const sprTextureLarge = 'https://portfoliodeland.s3.us-east-2.amazonaws.com/assets/spr-lesson-builder-dark-large.jpg';
// const sprTexturePlaceholder = 'https://portfoliodeland.s3.us-east-2.amazonaws.com/assets/spr-lesson-builder-dark-placeholder.jpg';
// const sprTexture = 'https://portfoliodeland.s3.us-east-2.amazonaws.com/assets/spr-lesson-builder-dark.jpg';

const disciplines = ['Django', 'Flask', 'React', 'Angular', 'PostgreSQL', 'Docker', 'Ubuntu', 'Management', 'WS2019', 'AWS', 'Git'];

const Home = () => {
  const {status} = useRouteTransition();
  const {hash, state} = useLocation();
  const initHash = useRef(true);
  const [visibleSections, setVisibleSections] = useState([]);
  const [scrollIndicatorHidden, setScrollIndicatorHidden] = useState(false);
  const intro = useRef();
  const projectOne = useRef();
  const projectTwo = useRef();
  const projectThree = useRef();
  const projectFour = useRef();
  const projectFive = useRef();
  const projectSix = useRef();
  // const projectFour = useRef();
  const details = useRef();
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    const revealSections = [intro, projectOne, projectTwo, projectThree, projectFour, projectFive, projectSix, details];
    // const revealSections = [intro, projectOne, projectTwo, projectThree, projectFour, details];

    const sectionObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const section = entry.target;
            observer.unobserve(section);
            if (visibleSections.includes(section)) return;
            setVisibleSections(prevSections => [...prevSections, section]);
          }
        });
      },
      {rootMargin: '0px 0px -10% 0px'}
    );

    const indicatorObserver = new IntersectionObserver(
      ([entry]) => {
        setScrollIndicatorHidden(!entry.isIntersecting);
      },
      {rootMargin: '-100% 0px 0px 0px'}
    );

    revealSections.forEach(section => {
      sectionObserver.observe(section.current);
    });

    indicatorObserver.observe(intro.current);

    return () => {
      sectionObserver.disconnect();
      indicatorObserver.disconnect();
    };
  }, [visibleSections]);


  // TOOD projects e basinca ucuncuye gidiyor onu duzelt
  useEffect(() => {
    const hasEntered = status === 'entered';
    const supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;
    let scrollObserver;
    let scrollTimeout;

    const handleHashchange = (hash, scroll) => {
      clearTimeout(scrollTimeout);
      const hashSections = [intro, projectOne, details];
      const hashString = hash.replace('#', '');
      const element = hashSections.filter(item => item.current.id === hashString)[0];
      if (!element) return;
      const behavior = scroll && !prefersReducedMotion ? 'smooth' : 'instant';
      const top = element.current.offsetTop;

      scrollObserver = new IntersectionObserver(
        (entries, observer) => {
          const [entry] = entries;
          if (entry.isIntersecting) {
            scrollTimeout = setTimeout(
              () => {
                element.current.focus();
              },
              prefersReducedMotion ? 0 : 400
            );
            observer.unobserve(entry.target);
          }
        },
        {rootMargin: '-20% 0px -20% 0px'}
      );

      scrollObserver.observe(element.current);

      if (supportsNativeSmoothScroll) {
        window.scroll({
          top,
          left: 0,
          behavior,
        });
      }
      else {
        window.scrollTo(0, top);
      }
    };

    if (hash && initHash.current && hasEntered) {
      handleHashchange(hash, false);
      initHash.current = false;
    }
    else if (!hash && initHash.current && hasEntered) {
      window.scrollTo(0, 0);
      initHash.current = false;
    }
    else if (hasEntered) {
      handleHashchange(hash, true);
    }

    return () => {
      clearTimeout(scrollTimeout);
      if (scrollObserver) {
        scrollObserver.disconnect();
      }
    };
  }, [hash, state, prefersReducedMotion, status]);

  return (
    <div className="home">
      <Helmet>
        <title>Ilke Deland Caglar | Full Stack Developer</title>
        <meta
          name="description"
          content="Portfolio of Ilke Deland Caglar – full stack developer."
        />
        <link rel="prefetch" href={iphone11} as="fetch" crossorigin=""/>
        <link rel="prefetch" href={macbookPro} as="fetch" crossorigin=""/>
      </Helmet>
      <Intro
        id="intro"
        sectionRef={intro}
        disciplines={disciplines}
        scrollIndicatorHidden={scrollIndicatorHidden}
      />
      <ProjectSummary
        id="project-1"
        sectionRef={projectOne}
        visible={visibleSections.includes(projectOne.current)}
        index={1}
        title="Software Engineer at Avail AI"
        description={[
          "Full-stack development of various products in the title review platform.",
          "Designed and implemented an OpenID Connect workflow, enabling seamless authentication and authorization for users. Python was used to develop endpoints connecting to Hydra.",
          "Led the design and implementation of a user-friendly admin panel using React, along with API development in Python and Flask.",
          "Improved the overall architecture and user experience of the digital mapping service using Python and Starlette, implementing new features and optimizations that led to increased user adoption.",
          "Designed and built a monthly report generation system for Avail using Python and Flask, automating ROI calculations based on platform usage and time savings."
        ]}
        buttonText="View Website"
        buttonLink="https://www.avail.ai/"
        model={{
          type: 'phone',
          alt: 'image',
          textures: [
            {
              src: availMobileTwo,
              srcSet: `${availMobileTwo} 254w, ${availMobileTwo} 508w`,
              placeholder: gamestackTexturePlaceholder,
            },
            {
              src: availMobileOne,
              srcSet: `${availMobileOne} 254w, ${availMobileOne} 508w`,
              placeholder: gamestackTexture2Placeholder,
            },
          ],
        }}
      />

      <ProjectSummaryButtonless
        id="project-2"
        sectionRef={projectTwo}
        visible={visibleSections.includes(projectTwo.current)}
        index={2}
        title="Software Development of Base Selimiye"
        description={[
          "Full-stack development of the website.",
          "Developed a performance-optimised, SEO-friendly website for a boutique hotel.",
          "Implemented image optimisation and integrated Google Ads for targeted promotion."
        ]}
        buttonText="View Website"
        buttonLink="/projects/slice"
        model={{
          type: 'phone',
          alt: 'image',
          textures: [
            {
              src: basePhone2,
              srcSet: `${gamestackTexture} 254w, ${basePhone2} 508w`,
              placeholder: gamestackTexturePlaceholder,
            },
            {
              src: basePhone1,
              srcSet: `${gamestackTexture2} 254w, ${basePhone1} 508w`,
              placeholder: gamestackTexture2Placeholder,
            },
          ],
        }}
      />

      <ProjectSummaryButtonless
        id="project-3"
        sectionRef={projectThree}
        visible={visibleSections.includes(projectThree.current)}
        index={3}
        title="Full Stack Developer at Udentify"
        description={[
          "Created a weekly report automation system, utilizing the \“docx\” python library to generate customformatted reports.",
          "Utilized Selenium web scraping techniques to automate the extraction of data from our company’s admin panel, including the collection of screenshots of various graphs.",
          "Conducted extensive testing and debugging to ensure that the APIs were reliable, scalable, and met the relevant security standards."
        ]}
        buttonText="View Website"
        buttonLink="https://www.udentify.co/"
        model={{
          type: 'laptop',
          alt: 'image',
          textures: [
            {
              src: undentifySmall,
              srcSet: `${undentifySmall} 800w, ${undentifyBig} 1440w`,
              placeholder: sprTexturePlaceholder,
            },
          ],
        }}
      />

      <ProjectSummary
        id="project-4"
        sectionRef={projectFour}
        visible={visibleSections.includes(projectFour.current)}
        index={4}
        title="Software Engineer at Epica"
        description={[
          "Led the design and development of the overall architecture. Apps were used for manufacturing and retail.",
          "Implemented Django signals and Celery tasks using Python to seamlessly integrate third-party providers, improving overall system efficiency and automating background processes.",
          "Designed and implemented a CI/CD pipeline.",
          "Developed Photoshop scripts for product management, reducing time spent on updating inventory."
        ]}
        buttonText="View Website"
        buttonLink="https://www.epicaleather.com/"
        model={{
          type: 'phone',
          alt: 'image',
          textures: [
            {
              src: epicaMobileTwo,
              srcSet: `${epicaMobileTwo} 254w, ${epicaMobileTwo} 508w`,
              placeholder: gamestackTexturePlaceholder,
            },
            {
              src: epicaMobileOne,
              srcSet: `${epicaMobileOne} 254w, ${epicaMobileOne} 508w`,
              placeholder: gamestackTexture2Placeholder,
            },
          ],
        }}
      />

      {/*/>*/}
      <ProjectSummary
        id="project-5"
        sectionRef={projectFive}
        visible={visibleSections.includes(projectFive.current)}
        index={5}
        title="Tabula"
        description={[
          "Built a SaaS platform to improve SME review management by providing actionable insights.",
          "Designed an intuitive UI with ReactJS and a robust Django backend."
        ]}
        buttonText="View Website"
        buttonLink="https://www.tabula.la/"
        model={{
          type: 'phone',
          alt: 'image',
          textures: [
            {
              src: tabulaMobileFour,
              srcSet: `${tabulaMobileFour} 254w, ${tabulaMobileFour} 508w`,
              placeholder: gamestackTexturePlaceholder,
            },
            {
              src: tabulaMobileFive,
              srcSet: `${tabulaMobileFive} 254w, ${tabulaMobileFive} 508w`,
              placeholder: gamestackTexture2Placeholder,
            },
          ],
        }}
      />

      <ProjectSummaryButtonless
        id="project-6"
        sectionRef={projectSix}
        visible={visibleSections.includes(projectSix.current)}
        index={6}
        title="Internship at King's College London 5G Lab"
        description={[
          "Worked as a member of a cross-functional team to develop a prototype for the government regulator Ofcom.",
          "Worked under the guidance of Prof. Mischa Dohler and alongside PhD students to conduct research in the field of telecommunication and wireless networks.",
          "Used Node.js to create a link between Blockchain and access points, enabling secure and decentralised communication between devices."
        ]}
        buttonText="View Project"
        buttonLink="/projects/slice"
        model={{
          type: 'laptop',
          alt: 'image',
          textures: [
            {
              src: blockChainSmall,
              srcSet: `${blockChainSmall} 980w, ${blockChainBig} 1376w`,
              placeholder: sliceTexturePlaceholder,
            },
          ],
        }}
      />


      <Profile
        sectionRef={details}
        visible={visibleSections.includes(details.current)}
        id="details"
      />
      <Footer/>
    </div>
  );
};

export default Home;
